var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-view"},[_c('div',[_c('el-image',{staticClass:"icon-empty",style:(_vm.imageStyle),attrs:{"src":_vm.iconEmpty}}),(_vm.showEmptyText)?_c('div',{staticClass:"empty-text"},[_vm._v(" "+_vm._s(_vm.emptyText || _vm.$t("el.common.noData"))+" ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }